import { render, staticRenderFns } from "./PopsSecondSubFolderClinic.vue?vue&type=template&id=15c98195&scoped=true"
import script from "./PopsSecondSubFolderClinic.vue?vue&type=script&lang=js"
export * from "./PopsSecondSubFolderClinic.vue?vue&type=script&lang=js"
import style0 from "./PopsSecondSubFolderClinic.vue?vue&type=style&index=0&id=15c98195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c98195",
  null
  
)

export default component.exports